import repository from './repsitory'

const resource = '/BankAccount'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addBankAccount (data) {
        return repository.post(`${resource}`, data)
    },
    updateBankAccount (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    remove (id) {
        return repository.delete(`${resource}/${id}`)
    },
}
